import { useMutation, useQueryClient } from 'react-query'
import { useToast } from '@chakra-ui/react'

import { fetchAPI } from '@/lib/api'
import { getErrorMsg, t } from '@/lib/helpers'

import { MESSAGES } from '../constants'
import { MessageFormInput } from '../types'
import { transformMessageInput } from '../utils'

const updateMessage = async ({
  form,
  id,
}: {
  form: MessageFormInput
  id: number
}) => {
  const formData = transformMessageInput(form)

  await fetchAPI({
    method: 'put',
    path: `/messages/${id}`,
    data: formData,
  })
}

export const useUpdateMessage = () => {
  const toast = useToast()
  const queryClient = useQueryClient()

  return useMutation(updateMessage, {
    onSuccess: async () => {
      await queryClient.refetchQueries([MESSAGES])

      toast({
        description: t('views.admin.messages.services.update_success'),
        status: 'success',
        position: 'top-right',
        isClosable: true,
      })
    },
    onError(error) {
      toast({
        description: getErrorMsg(error),
        status: 'error',
        position: 'top-right',
        variant: 'left-accent',
        isClosable: true,
      })
    },
  })
}
